import BaseButton from "../../../components/ui/BaseButton";
import BaseWrapper from "../../../components/ui/BaseWrapper";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import { ModuleType } from "../../../utils/enum";
import { useEffect } from "react";

const CreateEditProjectHeader = ({
  onSave,
  isLoading,
  isUpdated,
  onCancel,
  isEditable,
  setIsEditable,
}) => {
  const location = useLocation();
  const isEdit = location.pathname.toLowerCase().includes("edit");
  const navigate = useNavigate();
  const { getPermissionForModule } = useAuth();
  const { hasUpdateAccess } = getPermissionForModule(ModuleType.CLIENT_PROJECT);

  const [searchParams] = useSearchParams();
  const MODE_DIRECT = searchParams.get("mode") === "DIRECT";
  useEffect(() => {
    if (MODE_DIRECT) {
      setIsEditable(true);
    }
  }, [MODE_DIRECT]);
  return (
    <div
      className={`border-b border-zinc-300 bg-white w-full sticky top-0 z-10`}
    >
      <BaseWrapper>
        <div className="grid grid-cols-7 py-[7px] items-center">
          <div className="sm:col-span-3 col-span-7">
            <h3 className="font-light sm:text-left text-center">
              {isEdit
                ? `${isEditable ? "Edit" : ""} Project Details`
                : "Create New Project"}
            </h3>
          </div>

          {hasUpdateAccess && (
            <div className="sm:col-span-4 col-span-7 flex items-center justify-end gap-3">
              {!isEditable && isEdit ? (
                <BaseButton
                  variant="contained"
                  color="primary"
                  onClick={() => setIsEditable(true)}
                  className="py-[5px]"
                >
                  Edit Details
                </BaseButton>
              ) : (
                <>
                  {" "}
                  <BaseButton
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={
                      isEdit ? onCancel : () => navigate("/workBoard/projects")
                    }
                    className="py-[5px] sm:w-24 w-full"
                  >
                    Cancel
                  </BaseButton>
                  <BaseButton
                    loaderSize="24px"
                    isLoading={isLoading}
                    disabled={isLoading || !isUpdated}
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={onSave}
                    className="py-[5px] sm:w-32 w-full"
                  >
                    {isEdit ? " Update" : "Create Project"}
                  </BaseButton>
                </>
              )}
            </div>
          )}
        </div>
      </BaseWrapper>
    </div>
  );
};

export default CreateEditProjectHeader;
